import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

interface ITagProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 类型
   * @default primary
   */
  type?: 'primary' | 'info' | 'danger' | 'warning';
  /**
   * 圆角样式
   * @default false
   */
  round?: boolean;
  /**
   * 自定义标签颜色
   */
  color?: string;
  /**
   * 自定义文字颜色
   */
  textColor?: string;
  /**
   * 尺寸
   * @default normal
   */
  size?: 'normal' | 'small' | 'large';
}

const Tag: FC<PropsWithChildren<ITagProps>> = ({ className, children, type = 'primary', round = false, color, textColor, size = 'normal' }) => {
  const rootCls = classNames('ink-tag', { [`ink-tag--${type}`]: type, [`ink-tag--${size}`]: size, 'ink-tag--round': round }, className);
  const style = {
    ...(color ? { backgroundColor: color } : {}),
    ...(textColor ? { color: textColor } : {}),
  };

  return (
    <View className={rootCls} style={style}>
      {children}
    </View>
  );
};

export default Tag;
